import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const pointsCategory = (data) => {
  return instance.post(`${url.BASE_API_URL}point-categories/list`, data).then((res) => {
    return res;
  });
};

export const getpointList = (data) => {
    return instance.post(`${url.BASE_API_URL}points/list`, data).then((res) => {
      return res;
    });
  };
